import isValidCep from '@brazilian-utils/is-valid-cep';
import { createAlphanumericFormatter } from '../generators/index.js';
const POSTAL_CODE = 'postal-code';
const PostalCodeFormatter = createAlphanumericFormatter({
    invalidMessage: 'tws.formatter.postalCode.invalid',
    mask: '00000-000',
    name: POSTAL_CODE,
    validate: isValidCep,
});
export { POSTAL_CODE, PostalCodeFormatter, };
export default PostalCodeFormatter;
//# sourceMappingURL=postal-code.js.map